var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ul',_vm._l((_vm.bread),function(bread,index){return _c('li',{key:index},[(bread.path)?_c('router-link',{attrs:{"to":{path : bread.path }}},[_vm._v(" "+_vm._s(bread.name)+" ")]):[_vm._v(" "+_vm._s(bread.name)+" ")]],2)}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }